<div class="wrapper">
  <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[10px] pt-[30px]">
    <app-view-field
      [value]="form?.controls['basisOfPay']?.value"
      class="w-full col-span-1 locked-field"
      label="basis Of Pay"
    />
    @if (!form?.controls?.changeInQuantity?.disabled) {
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['changeInQuantity']"
        [hint]="form?.controls['quantity']?.value ? 'Existing quantity : ' + form.controls['quantity'].value : ''"
        [isDecimalAllowed]="true"
        [min]="-9999999999"
        [parentFormGroup]="form"
        class="w-full col-span-1"
        controlName="changeInQuantity"
        label="change In Quantity"
      />
    } @else {
      <app-view-field
        [value]="form?.controls['changeInQuantity']?.value"
        [required]="true"
        class="w-full col-span-1 locked-field"
        label="change In Quantity"
      />
    }
    @if (!form?.controls?.unitPrice?.disabled) {
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['unitPrice']"
        [parentFormGroup]="form"
        class="w-full col-span-1"
        controlName="unitPrice"
        label="unit Price ($)"
      />
    } @else {
      <app-view-field
        [value]="form?.controls['unitPrice']?.value"
        [required]="true"
        class="w-full col-span-1 locked-field"
        label="unit Price ($)"
      />
    }
    <app-view-field
      [value]="form?.controls['uom']?.value"
      class="w-full col-span-1 locked-field"
      label="uom"
    />
    <app-view-field
      [value]="(form?.controls['totalAmount']?.value | number:'1.2-2') || '0.00'"
      class="w-full col-span-2 locked-field"
      label="total Amount ($)"
    />
    @if (!form?.controls?.additionalWorkingDays?.disabled) {
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['additionalWorkingDays']"
        [isDecimalAllowed]="true"
        [parentFormGroup]="form"
        class="w-full col-span-2"
        controlName="additionalWorkingDays"
        label="additional Working Days"
      />
    } @else {
      <app-view-field
        [value]="form?.controls['additionalWorkingDays']?.value"
        [required]="true"
        class="w-full col-span-2 locked-field"
        label="additional Working Days"
      />
    }
  </div>
</div>
